"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CourierClient = void 0;
const api_1 = require("../core/api");
/**
 * Client that contains Message (mail/sms/viber/...) related operations
 */
class CourierClient {
    constructor(config) {
        this.config = config;
        this.api = new api_1.ApiService(config);
    }
    /**
     * Send the message packed in the Envelope object
     * @param body @type Envelope
     */
    send(body) {
        const { api } = this;
        return api.post(["messages"], body);
    }
}
exports.CourierClient = CourierClient;
//# sourceMappingURL=courier.client.js.map